import React, { useEffect } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { setLocation } from 'components/Booking-new/actions/actions';

import { useDispatch } from 'components/Booking-new/hooks';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import { pushGTMBookedOutLocationEvent, pushGTMChooseLocationEvent } from 'utils/gtm';

import { LocationType } from '../../../../Location/Variants/types';
import Location from '../../../../shared/LocationDetails';

import {
  ClosestLocations,
  ImageWrapper,
  NoDateWrapper,
  StyledLocationButton,
  StyledLocationsCardsWrapper,
} from './styles';

const NoDatesAvailable = ({
  stepTimeCF,
  locationCode,
  showImage,
  closestLocations,
  distancePlaceholder,
  setIsLoadingSlots,
  funnelType,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // trigger GTM event "Booked Out Location"
    pushGTMWithDelay(33, pushGTMBookedOutLocationEvent, { location: locationCode });
  }, []);

  function handleLocationChange(location) {
    setIsLoadingSlots(true);
    window.scrollTo(0, 0);

    pushGTMChooseLocationEvent(location.code, funnelType);
    dispatch(setLocation(location));
  }
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') handleLocationChange(location);
  };

  return (
    <div>
      <NoDateWrapper>
        {showImage && (
          <ImageWrapper>
            <GatsbyImage
              image={stepTimeCF?.noDatesImage?.gatsbyImageData}
              alt={stepTimeCF?.noDatesImage?.title}
              loading="eager"
            />
          </ImageWrapper>
        )}
        <ClosestLocations>
          <Typography variant="DS_h3" component="h3">
            {stepTimeCF?.noDatesButton || 'Choose another clinic'}
          </Typography>
          <StyledLocationsCardsWrapper>
            {closestLocations.map(location => (
              <StyledLocationButton
                aria-label="button"
                role="button"
                tabIndex="0"
                key={location.code}
                onClick={() => handleLocationChange(location)}
                onKeyDown={handleKeyDown}
              >
                <Location data={{ ...location, distancePlaceholder }} />
              </StyledLocationButton>
            ))}
          </StyledLocationsCardsWrapper>
        </ClosestLocations>
      </NoDateWrapper>
    </div>
  );
};

NoDatesAvailable.defaultProps = {
  showImage: true,
};

NoDatesAvailable.propTypes = {
  stepTimeCF: PropTypes.object,
  navigateToPreviousStep: PropTypes.func,
  locationCode: PropTypes.string,
  showImage: PropTypes.bool,
  closestLocations: PropTypes.oneOfType([LocationType, PropTypes.arrayOf(LocationType)]),
  distancePlaceholder: PropTypes.string,
};

export default NoDatesAvailable;
